module.exports = __webpack_public_path__ + "static/WEDDING E&M-596-c9e11f8efbc3220eb304e14bf9b1ece0.jpg";